<mat-card class="slidecontent">
    <div class="headcontent">
        <div class="pophead">
            <h3>Create Facility</h3>
            <button mat-icon-button (click)="CloseSchedule(false)">
                <mat-icon class="close">close</mat-icon>
            </button>
        </div>

    </div>
    <div class="dialog_content">
        <mat-form-field appearance="">
            <mat-label>Facility Name </mat-label>
            <input matInput value="David Williams - Heart Surgery">
        </mat-form-field>
        <mat-form-field appearance="">
            <mat-label>Scheduler Name </mat-label>
            <input matInput value="Matt Mcalpin">
        </mat-form-field>
        <mat-form-field appearance="">
            <mat-label>Schedular Email </mat-label>
            <input matInput value="matt@flowtrics.com">
        </mat-form-field>
        <mat-form-field appearance="">
            <mat-label>Facility Phone Number </mat-label>
            <input matInput value="9879878987">
        </mat-form-field>

    </div>


    <div class="actionBtn">
        <button mat-flat-button class="calltoaction" type="submit" color="basic"> Close </button>
        <button mat-flat-button class="calltoaction" type="submit" color="primary">Send Add Request </button>
    </div>
</mat-card>


<div class="overlay" (click)="CloseSchedule(false)"></div>